import React, { useState } from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import FilterRecordingRequestDialogWrapper from "./FilterCard/FilterRecordingRequestDialogWrapper";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const RecordingRequestListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [isOpenFilterDialog, setIsOpenFilterDialog] = useState(false);
  return (
    <SideNavLayout>
      <div className="flex flex-col h-full ">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader
            pageTitle="Recording Requests"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton
            isFilter
            onFilterClick={() => setIsOpenFilterDialog(true)}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col ">
          <ATMTable
            rows={rows}
            columns={columns}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
        {isOpenFilterDialog && (
          <FilterRecordingRequestDialogWrapper
            onClose={() => setIsOpenFilterDialog(false)}
          />
        )}
      </div>
    </SideNavLayout>
  );
};

export default RecordingRequestListing;
